import React from 'react'
import whatsapp from 'assets/icons/whatsapp-fill.svg'

function SupportSection() {
  return (
    <section className={`bg-sand flex w-full flex-col items-center justify-center bg-[#E5E7EB] py-8`}>
      <div className={`flex w-11/12 flex-col items-center justify-center gap-4 md:flex-row`}>
        <div className='flex flex-col items-center justify-center gap-4'>
          <img src={whatsapp} alt='Whatsapp' className='h-14 w-14 md:h-20 md:w-20' />

          <figcaption className='text-2xl font-semibold md:text-5xl'>Atendimento Personalizado</figcaption>

          <p className='text-center text-xl md:text-2xl'>
            Garanta um atendimento humanizado e personalizado dedicado a você!
          </p>

          <button className='rounded-full border-2 border-[#5D7053] p-4 px-8 text-xl font-medium uppercase text-[#5D7053] transition-all duration-500 hover:opacity-75'>
            <a
              href='https://api.whatsapp.com/send?phone=5543999540770&text=Ol%C3%A1%2C%20Vim%20pelo%20site.'
              target='_blank'
            >
              Fale com nosso time
            </a>
          </button>
        </div>
      </div>
    </section>
  )
}

export default SupportSection
